import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosRequestConfig } from 'axios';
import { setHeaders } from '../services/apiService';
import { getAuthToken } from '../services/authService';
import { handleHTTPError } from '../pages/errorHandler/errorHandlerHelper';

type ApiThunkArgs = {
  url: string;
  query?: string;
  method?: string;
  data?: any;
  params?: Record<string, any>;
  headers?: Record<string, string>;
};

export function createApiThunk<T = any>(
  typePrefix: string,
  apiFn: (args: ApiThunkArgs) => Promise<T>,
) {
  return createAsyncThunk<T, ApiThunkArgs>(typePrefix, async (args, thunkAPI) => {
    try {
      return await apiFn(args);
    } catch (err: any) {
      handleHTTPError(err, thunkAPI.dispatch as AppDispatch);
      const message = err?.response?.data?.message || err?.message || 'API Error';
      return thunkAPI.rejectWithValue(message);
    }
  });
}

export async function apiCall({
  url,
  method = 'GET',
  data,
  params,
  headers = {},
}: {
  url: string;
  method?: string;
  data?: any;
  params?: Record<string, any>;
  headers?: Record<string, string>;
}) {
  let config: AxiosRequestConfig = {
    url,
    method,
    headers: {
      ...headers,
    },
    data,
    params,
  };
  config = setHeaders(config);

  const response = await axios(config);
  return response.data;
}

export async function graphqlCall({
  url,
  query,
  variables = {},
  headers = {},
}: {
  url: string;
  query: string;
  variables?: Record<string, any>;
  headers?: Record<string, string>;
}) {
  let config: AxiosRequestConfig = {
    url,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${getAuthToken()}`,
      ...headers,
    },
    data: JSON.stringify({ query, variables }),
  };
  config = setHeaders(config);

  const response = await axios(config);
  return response.data;
}
